export type ModuleKey =
  | 'current_accounts'
  | 'products'
  | 'cash'
  | 'income_expense'
  | 'checks'
  | 'profile';

export const ALL_MODULES: ModuleKey[] = [
  'current_accounts',
  'products',
  'cash',
  'income_expense',
  'checks',
  'profile',
];

export const MODULE_LABELS: Record<ModuleKey, string> = {
  current_accounts: 'Cari Hesaplar',
  products: 'Stok Yönetimi',
  cash: 'Kasa/Banka',
  income_expense: 'Gelir-Gider',
  checks: 'Çekler',
  profile: 'Profil',
};

export const normalizeAllowedModules = (value: unknown, moduleType?: string): ModuleKey[] => {
  let parsed: unknown = value;

  if (typeof value === 'string') {
    try {
      parsed = JSON.parse(value);
    } catch {
      parsed = [];
    }
  }

  if (!Array.isArray(parsed) || parsed.length === 0) {
    if (moduleType === 'checks') {
      return ['checks', 'profile'];
    }
    return [...ALL_MODULES];
  }

  const allowed = parsed.filter((m): m is ModuleKey => ALL_MODULES.includes(m as ModuleKey));
  if (!allowed.includes('profile')) {
    allowed.push('profile');
  }
  return Array.from(new Set(allowed));
};

export const hasModuleAccess = (allowedModules: ModuleKey[], module: ModuleKey): boolean =>
  allowedModules.includes(module);
